<template>
  <!-- //会员到期提醒 -->
  <el-dialog
    :visible.sync="daoqiDialogVisible"
    width="1094px"
    height="534px"
    center
    style="margin-top: 10vh"
  >
    <div class="daoqitishi">
      <div class="leftbgimg">
        <img src="static/img/sign-login.png" alt="" />
      </div>
      <div class="rightcontain">
        <p>
          您的vip权限还有<br /><span>{{ showDiffDay }}天</span
          >过期，请及时续费。
        </p>
        <button class="relbutton" @click="jumpTo()">续费</button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'memberRemind',
  data () {
    return {
      daoqiDialogVisible: false,
      userInfo: localStorage.userinfo ? JSON.parse(localStorage.userinfo) : {},
      showDiffDay: 0
    }
  },
  mounted () {
    this.judge()
  },
  methods: {
    jumpTo () {
      this.$router.push({ 'path': '/products' })
    },
    judge () {

      let daoqi = this.userInfo.vipValidityDate
      if (daoqi) {
        let now = new Date().toLocaleString()
        let diffdays = this.getDiffDay(daoqi, now)
        // console.log(diffdays, 'diffdays')
        if (diffdays <= 3) {
          if (diffdays <= 0) {
            this.showDiffDay = 0
          } else {
            this.showDiffDay = diffdays
          }
          this.daoqiDialogVisible = true
        }

      }
    },
    getDiffDay (date_1, date_2) {
      let totalDays, diffDate
      let myDate_1 = Date.parse(date_1)
      let myDate_2 = Date.parse(date_2)
      diffDate = Math.abs(myDate_1 - myDate_2)
      totalDays = Math.floor(diffDate / (1000 * 3600 * 24))
      return totalDays
    },

  }

}
</script>

<style scoped lang="less">
/deep/.el-dialog--center .el-dialog__body,
/deep/.el-dialog__header {
  padding: 0;
}
/deep/.el-dialog {
  border-radius: 10px;
}
p,
div {
  margin: 0;
  padding: 0;
}
img {
  width: 100%;
  height: 100%;
}
.daoqitishi {
  display: flex;
  justify-content: space-between;
  .leftbgimg {
    height: 534px;
    width: auto;
  }
  .rightcontain {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    p {
      font-family: "FangZheng-FanTi-Kaiti";
      color: #3366cc;
      font-size: 38px;
      font-weight: 600;
      line-height: 80px;
      text-align: center;
      span {
        font-size: 60px;
        color: #d9c188;
      }
    }
    .zitikai {
      font-family: KaiTi, "楷体", SimKai, "华文楷体", "STKaiti", "BiauKai",
        serif;
    }
    .relbutton {
      font-family: "FangZheng-FanTi";
      margin-top: 80px;
      width: 206px;
      height: 48px;
      line-height: 48px;
      background: #3366cc;
      border-radius: 24px;
      color: #fff;
      font-size: 30px;
      font-weight: 600;
      cursor: pointer;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/memberRemind.vue